import { DateTime } from "luxon";
import { v4 as uuid } from "uuid";
import { NFTOwnership } from "../nft";
import { toJSON, unique } from "../utils";
export var UsageInterval;
(function (UsageInterval) {
    UsageInterval["DAY"] = "day";
    UsageInterval["WEEK"] = "week";
    UsageInterval["MONTH"] = "month";
    UsageInterval["YEAR"] = "year";
})(UsageInterval || (UsageInterval = {}));
export class NFTEventTierUsageConstraint {
    constructor(params) {
        var _a;
        this.boundToUser = !!(params === null || params === void 0 ? void 0 : params.boundToUser);
        this.limit = (_a = params === null || params === void 0 ? void 0 : params.limit) !== null && _a !== void 0 ? _a : 1;
        if (params === null || params === void 0 ? void 0 : params.interval)
            this.interval = params.interval || UsageInterval.DAY;
    }
    get intervalStart() {
        if (!this.interval)
            return 0;
        try {
            return DateTime.now().startOf(this.interval).valueOf();
        }
        catch (error) {
            return 0;
        }
    }
    get json() {
        return toJSON(this);
    }
}
export class NFTEventUsage {
    constructor(params) {
        this.id = params.id || uuid();
        this.eventId = params.eventId;
        this.tierId = params.tierId;
        this.validCount = Number(params.validCount || 1);
        this.timestamp = Number(params.timestamp || new Date().valueOf());
        if (params.userId)
            this.userId = params.userId;
        if (params.wallets)
            this.wallets = unique(params.wallets);
        if (params.email)
            this.email = params.email.toLowerCase();
        if (params.nfts)
            this.nfts = params.nfts.map((nft) => new NFTOwnership(nft));
        if (this.nfts)
            this.nftIds = unique(this.nfts.map((nft) => nft.id));
        if (params.whitelist)
            this.whitelist = params.whitelist;
        this.identifiers = unique([
            ...(params.identifiers || []),
            ...(this.wallets || []),
            this.userId || "",
            this.email || "",
        ]);
    }
    get json() {
        return toJSON(this);
    }
}
